<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <archive-table
      icon="account_balance_wallet"
      calculationEntity="Commissions"
      :url="odata.url"
      identifier="commissionsArchive"
    ></archive-table>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="purple"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ArchiveTable from "../components/ArchiveTable";
import { planSetter } from "../mixins/planSetter";

export default {
  name: "commissions-archive",
  components: {
    ArchiveTable
  },
  data() {
    return {
      calculationEntity: "Commissions",
    };
  },
  mixins: [planSetter],
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("common", ["messages"]),
    odata: function() {
      return {
        url: "plans/" + this.selectedPlan.Id + "/commissions"
      };
    }
  },
  watch: {},
  async mounted() {},
  methods: {
    /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
  }
};
</script>


